import { Locale } from '../../../../core/i18n/Locale';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { handleResponse } from '../../../shared/types/handlers';

import { NormalizedUserFromPyrite, normalizeUserFromPyrite, UserFromPyrite } from './normalizer';

type FetchUserFromPyriteResponse = {
    user: UserFromPyrite;
};

async function fetchUserFromPyrite(
    locale: Locale,
    jwt?: string,
): Promise<FetchUserFromPyriteResponse> {
    const headers = jwt
        ? {
              Cookie: `evaneos_auth_token=${jwt}`,
          }
        : undefined;

    const response = await fetch(generateUrl('api_user', locale, {}, true), {
        credentials: 'same-origin',
        headers,
    });

    return handleResponse<FetchUserFromPyriteResponse>(response);
}

export async function getUserFromPyrite(
    locale: Locale,
    jwt?: string,
): Promise<NormalizedUserFromPyrite> {
    const { user } = await fetchUserFromPyrite(locale, jwt);

    return normalizeUserFromPyrite(user);
}
